// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const HeartFilledIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19.32 7a4.29 4.29 0 00-1.89-1.66A3.9 3.9 0 0015 5.09a4 4 0 00-2 1.23l-.91 1-.91-1A4 4 0 009 5.09a3.89 3.89 0 00-2.47.26A4.22 4.22 0 004.68 7 4.6 4.6 0 004 9.39a4.19 4.19 0 001.44 3.1l5.65 6.12.08.07a1.24 1.24 0 001.66 0l5.72-6.17A4.24 4.24 0 0020 9.4a4.54 4.54 0 00-.68-2.4z"/></svg>'} />;

HeartFilledIcon.displayName = 'HeartFilledIcon';

export default HeartFilledIcon;
